import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store";
import { getBridgeToken, setBridgeToken } from "@/utils/auth";
const qs = require("qs");

// 在文件顶部添加重试次数常量
const MAX_RETRY_TIMES = 3;

// 参数格式化函数
const paramsFormat = function (params) {
  let resParams = {};
  for (let i in params) {
    let val = params[i];
    if (Array.isArray(val) && val.length > 0) {
      resParams[i] = val;
    } else if (val && typeof val === "object" && JSON.stringify(val) != "{}") {
      resParams[i] = val;
    } else if (val || val === 0) {
      resParams[i] = val;
    }
  }
  return resParams;
};

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BRIDGE_API,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  },
  // // 处理https证书问题
  // httpsAgent: new https.Agent({
  //   rejectUnauthorized: false
  // })
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // console.log('Target URL:', `${process.env.VUE_APP_BRIDGE_API}/crosschain/records`)
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    // console.log('getBridgeToken',getBridgeToken())
    // if (getBridgeToken()) {
    //   config.headers["Authorization"] = "Bearer " + getBridgeToken();
    // }

    config.vconfig = config.vconfig || {};

    if (config.vconfig.ContentType) {
      config.headers["Content-Type"] = config.vconfig.ContentType;
    }

    if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
      config.data = qs.stringify(config.data);
    }

    if (config.vconfig.responseType) {
      config.responseType = config.vconfig.responseType;
    }

    if (config.params) {
      config.params = paramsFormat(config.params);
    }

    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  async (res) => {
    const code = res.data.code;
    if (res.config.vconfig && res.config.vconfig.noErr) {
      return res;
    }

    // 添加重试次数计数
    res.config.retryTimes = res.config.retryTimes || 0;

    // if ((code == "-5" || res.data.error == "please relogin") && res.config.retryTimes < MAX_RETRY_TIMES) {
    //   try {
    //     // 增加重试次数
    //     res.config.retryTimes++;

    //     // 调用获取新token的接口
    //     console.log(process.env.NODE_ENV)
    //     const tokenResponse = await axios({
    //       url: process.env.NODE_ENV === 'development' 
    //         ? '/oauth/access_token'
    //         : `https://127.0.0.1:3049/oauth/access_token`,
    //       method: 'post',
    //       headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //       },
    //       data: qs.stringify({
    //         grant_type: 'client_credentials',
    //         client_id: 'test',
    //         client_secret: '36f028580bb02cc8272a9a020f4200e346e276ae664e45ee80745574e2f5ab80'
    //       })
    //     });

    //     if (tokenResponse.data && tokenResponse.data.access_token) {
    //       const newToken = tokenResponse.data.access_token;
    //       setBridgeToken(newToken);
    //       // 更新原始请求的配置
    //       const config = res.config;
    //       config.headers['Authorization'] = `Bearer ${newToken}`;

    //       // 直接返回重试请求
    //       return service(config);
    //     }
    //   } catch (error) {
    //     console.error(`Retry failed ${res.config.retryTimes} times:`, error);
    //     if (res.config.retryTimes >= MAX_RETRY_TIMES) {
    //       console.error('Max retry times reached');
    //       return Promise.reject(error);
    //     }
    //     // 如果还未达到最大重试次数，继续重试
    //     return service(res.config);
    //   }
    // } else
    if (code !== 0) {
      // Notification.error({
      //   title: res.data.error
      // });
      return Promise.reject(res.data);
    } else {
      return res.data;
    }
  },
  error => {
    Message({
      message: error,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service; 